import React, { useEffect } from "react";
import Head from "next/head";
import { useRouter } from "next/router";

import { routes } from "@/utils/routes";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

const DevelopersPage = () => {
  const router = useRouter();

  useEffect(() => {
    router.push(routes.developers);
  }, [router]);

  return (
    <>
      <Head>
        <title>{seoData.DEV_OVERVIEW.title}</title>
        <SeoMetaData data={seoData.DEV_OVERVIEW} />
      </Head>
    </>
  );
};

export default DevelopersPage;
